/* Filtri di collezione.
 *
 * Al cambio di un filtro chiediamo a Shopify la sezione ri-renderizzata
 * (Section Rendering API) e innestiamo due zone: i filtri e i risultati. Niente
 * ricarica di pagina, ma la pagina ricaricata darebbe lo stesso identico
 * risultato — l'HTML arriva dal server, non lo costruiamo qui.
 *
 * Perche' non facets.js di Dawn: quel file dipende da una dozzina di ID e
 * classi della sua impaginazione (#FacetsWrapperDesktop, .mobile-facets__list,
 * menu-drawer, show-more-button). Riusarlo significa adottarne la struttura,
 * cioe' il "tema preconfezionato" che il marchio ha fra le anti-referenze.
 *
 * Quello che va fatto a mano, e che si dimentica:
 *   - la cronologia, perche' il tasto indietro deve tornare al filtro di prima;
 *   - lo stato aperto dei <details>, che il ri-render azzererebbe;
 *   - la messa a fuoco, che sparirebbe insieme all'elemento sostituito;
 *   - l'annuncio del nuovo conteggio a chi naviga con un lettore di schermo.
 */
(function () {
  'use strict';

  // Caricato due volte, registrerebbe due volte ogni gestore: al clic su
  // "mostra altri" la pagina successiva verrebbe accodata due volte e ogni
  // prodotto comparirebbe doppio. Succede appena una sezione o un banco di
  // prova aggiunge lo stesso <script> per conto suo.
  if (window.vdmFiltriPronti) return;
  window.vdmFiltriPronti = true;

  var modulo = document.getElementById('VdmFiltri');
  var pannello = document.getElementById('VdmPannello');
  var risultati = document.getElementById('VdmRisultati');
  if (!modulo || !pannello || !risultati) return;

  // L'id della sezione arriva da Liquid. Cercarlo con querySelector('.shopify-section')
  // prenderebbe la prima sezione della pagina, che e' l'intestazione.
  var radice = risultati.closest('[data-sezione]');
  var idSezione = radice ? radice.dataset.sezione : null;
  var inVolo = null;

  /* --- lettura del modulo -------------------------------------------------- */

  // I campi vuoti non finiscono nell'indirizzo: "?filter.v.price.gte=" fa
  // sparire tutti i prodotti invece di non filtrare niente.
  function indirizzo() {
    var dati = new FormData(modulo);
    var parti = [];
    dati.forEach(function (valore, chiave) {
      if (valore === '') return;
      parti.push(encodeURIComponent(chiave) + '=' + encodeURIComponent(valore));
    });
    return parti.join('&');
  }

  /* --- innesto ------------------------------------------------------------- */

  function aperti() {
    var stato = {};
    pannello.querySelectorAll('[data-filtro]').forEach(function (d) {
      stato[d.dataset.filtro] = d.open;
    });
    return stato;
  }

  function riapri(stato) {
    pannello.querySelectorAll('[data-filtro]').forEach(function (d) {
      if (stato[d.dataset.filtro]) d.open = true;
    });
  }

  // Dopo la sostituzione l'elemento che aveva la messa a fuoco non esiste piu'.
  // Senza questo, chi filtra da tastiera viene sbalzato all'inizio della pagina
  // a ogni scelta.
  function ritrovaFuoco(riferimento) {
    if (!riferimento) return;
    var nuovo = riferimento.id
      ? document.getElementById(riferimento.id)
      : pannello.querySelector('[name="' + riferimento.name + '"]');
    if (nuovo) nuovo.focus({ preventScroll: true });
  }

  function innesta(html, riferimento) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var stato = aperti();

    var nuovoPannello = doc.getElementById('VdmPannello');
    var nuoviRisultati = doc.getElementById('VdmRisultati');
    if (!nuovoPannello || !nuoviRisultati) return;

    pannello.innerHTML = nuovoPannello.innerHTML;
    risultati.innerHTML = nuoviRisultati.innerHTML;

    modulo = document.getElementById('VdmFiltri');
    riapri(stato);
    ritrovaFuoco(riferimento);
  }

  /* --- richiesta ----------------------------------------------------------- */

  function carica(query, spingi, riferimento) {
    var base = window.location.pathname;
    var completo = base + (query ? '?' + query : '');

    if (inVolo) inVolo.abort();
    inVolo = new AbortController();
    risultati.setAttribute('aria-busy', 'true');
    document.querySelector('.vdm-collezione').classList.add('vdm-collezione--attesa');

    var richiesta = base + '?' + (query ? query + '&' : '');
    fetch(richiesta + 'section_id=' + idSezione, { signal: inVolo.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        innesta(html, riferimento);
        if (spingi) window.history.pushState({ vdm: query }, '', completo);
      })
      .catch(function (e) {
        // Interruzione volontaria: un altro filtro e' stato scelto nel
        // frattempo, la richiesta successiva sta gia' arrivando.
        if (e.name === 'AbortError') return;
        // Rete caduta o sezione non trovata: invece di lasciare la griglia
        // vecchia sotto filtri nuovi — cioe' una bugia — ricarichiamo davvero.
        window.location.href = completo;
      })
      .finally(function () {
        risultati.removeAttribute('aria-busy');
        var s = document.querySelector('.vdm-collezione');
        if (s) s.classList.remove('vdm-collezione--attesa');
      });
  }

  /* --- eventi -------------------------------------------------------------- */

  var attesa = null;

  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('#VdmFiltri')) return;
    var riferimento = e.target;

    // I campi di prezzo si digitano: filtrare a ogni tasto manderebbe una
    // richiesta per cifra e mostrerebbe risultati per "3" mentre si scrive
    // "300".
    var ritardo = e.target.type === 'number' ? 500 : 0;
    clearTimeout(attesa);
    attesa = setTimeout(function () {
      carica(indirizzo(), true, riferimento);
    }, ritardo);
  });

  // I collegamenti "togli" e "azzera" sono href veri: funzionano senza
  // JavaScript, e qui li intercettiamo per evitare la ricarica.
  document.addEventListener('click', function (e) {
    var togli = e.target.closest && e.target.closest('[data-togli]');
    if (togli && togli.href) {
      e.preventDefault();
      carica(togli.search.replace(/^\?/, ''), true, null);
      return;
    }

    var altro = e.target.closest && e.target.closest('[data-altro]');
    if (altro && altro.href) {
      e.preventDefault();
      accoda(altro);
    }
  });

  window.addEventListener('popstate', function () {
    carica(window.location.search.replace(/^\?/, ''), false, null);
  });

  /* --- una tendina per volta ----------------------------------------------- */

  // Su schermo largo il corpo del filtro esce dal flusso e si apre sopra la
  // pagina: aprendone due si sovrappongono e diventano illeggibili. Nel
  // pannello mobile invece sono righe impilate, e tenerne aperte piu' d'una e'
  // comodo — quindi la regola vale solo dove le tendine si sovrappongono.
  var sovrapposte = window.matchMedia('(min-width: 900px)');

  function chiudiTendine(tranne) {
    pannello.querySelectorAll('[data-filtro][open]').forEach(function (d) {
      if (d !== tranne) d.open = false;
    });
  }

  // `toggle` non risale il DOM: senza la fase di cattura questo non scatta mai.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-filtro]') || !d.open) return;
    if (!sovrapposte.matches) return;
    chiudiTendine(d);
  }, true);

  // Un clic fuori chiude: e' quello che ci si aspetta da una tendina, e senza
  // resterebbe aperta mentre si guarda la griglia sotto.
  document.addEventListener('click', function (e) {
    if (!sovrapposte.matches) return;
    if (e.target.closest && e.target.closest('[data-filtro]')) return;
    chiudiTendine(null);
  });

  /* --- pannello mobile ----------------------------------------------------- */

  // Lo stato aperto sta sul <body>, non dentro il pannello: il pannello viene
  // sostituito a ogni filtro e si richiuderebbe da solo a meta' scelta.
  var APERTO = 'vdm-filtri-aperti';

  function apri() {
    document.body.classList.add(APERTO);
    var corpo = document.querySelector('[data-corpo-filtri]');
    var bottone = document.querySelector('[data-apri-filtri]');
    if (bottone) bottone.setAttribute('aria-expanded', 'true');
    if (corpo) {
      var primo = corpo.querySelector('summary, button, input');
      if (primo) primo.focus({ preventScroll: true });
    }
  }

  function chiudi() {
    if (!document.body.classList.contains(APERTO)) return;
    document.body.classList.remove(APERTO);
    var bottone = document.querySelector('[data-apri-filtri]');
    if (bottone) {
      bottone.setAttribute('aria-expanded', 'false');
      bottone.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-apri-filtri]')) apri();
    else if (e.target.closest && e.target.closest('[data-chiudi-filtri]')) chiudi();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Dentro una tendina, Esc chiude la tendina e riporta il fuoco sul suo
    // nome: chiudere e lasciare il fuoco nel vuoto perde il segno di dove si
    // era. Solo se non c'e' nessuna tendina aperta, Esc chiude il pannello.
    var dentro = document.activeElement
      && document.activeElement.closest
      && document.activeElement.closest('[data-filtro][open]');
    if (dentro) {
      dentro.open = false;
      var voce = dentro.querySelector('summary');
      if (voce) voce.focus({ preventScroll: true });
      return;
    }
    if (pannello.querySelector('[data-filtro][open]') && sovrapposte.matches) {
      chiudiTendine(null);
      return;
    }
    chiudi();
  });

  /* --- "mostra altri" ------------------------------------------------------ */

  // Aggiunge la pagina successiva in coda invece di sostituire la griglia: chi
  // ha gia' scorso venti prodotti non deve ritrovarsi in cima.
  function accoda(bottone) {
    var url = new URL(bottone.href, window.location.origin);
    bottone.classList.add('vdm-btn--attesa');
    bottone.setAttribute('aria-busy', 'true');

    fetch(url.pathname + url.search + '&section_id=' + idSezione)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var griglia = risultati.querySelector('[data-griglia]');
        var nuove = doc.querySelector('[data-griglia]');
        if (!griglia || !nuove) throw new Error('griglia assente');

        var primaNuova = null;
        Array.prototype.forEach.call(nuove.children, function (cella, i) {
          var copia = cella.cloneNode(true);
          // La cella doppia vale solo in testa alla collezione: ripeterla a
          // ogni pagina trasformerebbe un accento in un motivo.
          copia.classList.remove('vdm-piastrella--doppia');
          if (i === 0) primaNuova = copia;
          griglia.appendChild(copia);
        });

        var seguito = doc.querySelector('.vdm-seguito');
        var vecchio = risultati.querySelector('.vdm-seguito');
        if (vecchio) {
          if (seguito) vecchio.innerHTML = seguito.innerHTML;
          else vecchio.remove();
        }

        window.history.replaceState({ vdm: url.search }, '', url.pathname + url.search);

        // Porta la lettura sul primo prodotto appena arrivato, altrimenti dopo
        // il clic la messa a fuoco resta su un bottone che si e' spostato.
        if (primaNuova) {
          primaNuova.setAttribute('tabindex', '-1');
          primaNuova.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        window.location.href = bottone.href;
      });
  }
})();
